export default __webpack_public_path__ + "static/assets/d47549bb6e9f027aec84dff992940caf.svg";